import { useState } from 'react'

import { PAGE_SIZE } from '@/features/dashboard/lib/format'

/**
 * A long list a page at a time (owner, 2026-10-18: "paginations here for
 * such long list"): ten rows, and a footer with no words -- ‹, the range in
 * mono, ›. The page goes back to the first whenever what is listed or its
 * order changes, so a re-sort never lands the reader mid-list.
 */
export function usePage(resetOn: readonly unknown[]): [number, (page: number) => void] {
  const [state, setState] = useState<{ on: readonly unknown[]; page: number }>({
    on: resetOn,
    page: 0,
  })
  const same =
    state.on.length === resetOn.length && state.on.every((d, i) => Object.is(d, resetOn[i]))
  return [
    same ? state.page : 0,
    (page) => {
      setState({ on: resetOn, page })
    },
  ]
}

export const pageOf = <T>(items: readonly T[], page: number): T[] =>
  items.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE)
